<div class="bg-white p-3">
    <h1>{{'ERROR_FEATURE_INACTIVATED' | translate}}</h1>
    <p>
        {{'ERROR_FEATURE_INACTIVATED_DESCRIPTION' | translate}}
    </p>
</div>
